var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsitebannerwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6945_1387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56815 9.99097H5.40581L5.40581 7.82866L7.56815 7.82866L7.56815 9.99097ZM10.3036 9.99097H8.14128V7.82866L10.3036 7.82866V9.99097ZM4.83266 9.99097L2.67034 9.99097L2.67034 7.82866H4.83266L4.83266 9.99097ZM10.3036 3.1523L10.3036 7.13827L2.67035 7.13827L2.67035 3.1523L10.3036 3.1523ZM11.3978 2.006L1.60221 2.006L1.60221 10.994L11.3978 10.994L11.3978 2.006ZM0 12.5831L0 0.41684L13 0.41684L13 12.5832L0 12.5831Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6945_1387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsitebannerwhite);
export default __webpack_public_path__ + "static/media/websitebannerwhite.d02f8edc80258cae52c55e259fa65131.svg";
export { ForwardRef as ReactComponent };